export var REEDIT_RECALL_MSG_TIME = 1000 * 60 * 2;
export var SHOW_RECALL_BTN_MSG_TIME = 1000 * 60 * 2;
export var MIN_VALUE = Number.MIN_VALUE;
export var MAX_UPLOAD_FILE_SIZE = 100;
export var ALLOW_AT = 'yxAllowAt';
